const BENEFIT_MIN_WIDTH = 192;

const BENEFIT_TIMEOUT = 3000;

const DEFAULT_LOCALE = 'en-GB';

export { BENEFIT_MIN_WIDTH, BENEFIT_TIMEOUT, DEFAULT_LOCALE };
